<template>
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="mashupModalLabel">Error Processing Dataset</h5>

            <button type="button" class="btn-close" @click="$emit('closeModal')"></button>
          </div>
          <div class="modal-body">
            <p>There was an error while processing the Dataset: {{this.passedMashupEr}}</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-light" @click="$emit('closeModal')">Cancel</button>
          </div>
        </div>
</template>
<script>
import axios from 'axios';
import { onMounted, ref } from "vue";
export default {
  name: 'ModalMashupDialog',
  props: {
    passedModalData: "",
    passedMashupSi: "",
    passedMashupDv: "",
    passedMashupBf: "",
    passedMashupRf: "",
    passedMashupEr: "",
    passedMashupFt: []
  },
  data(){
    return{
      mashupRetainFilename: '',
      mashupFirstName: '',
      mashupLastName: '',
      mashupAddress: '',
      mashupZipCode: '',
      mashupBaseline: '',
      firstNameOptions: [],
      lastNameOptions: [],
      addressOptions: [],
      zipCodeOptions: [],
      baselineOptions: []
    }
  },
  methods: {
    
  },
  mounted() {
    
  }
}

</script>